import { ChevronsRight, CreditCard, DollarSign, Globe2, MessageSquare, Send, Shield } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const SeamlessPayments = () => {
    const features = [
        {
            icon: <DollarSign className="w-6 h-6 text-green-500" />,
            title: "Features of the Crypto Wallet App",
            description: "Security focused Registration: Users must register and log in using a mobile number. Only the number associated with the active SIM card will allow registration and login, enhancing security",
            bgColor: "bg-red-50/90",
        },
        {
            icon: <CreditCard className="w-6 h-6 text-purple-500" />,
            title: "KYC Compliance",
            description: "Mandatory KYC for Deposits and Withdrawals: To ensure compliance and security, KYC verification is required before users can deposit or withdraw funds",
            bgColor: "bg-white/90",
        },
        {
            icon: <MessageSquare className="w-6 h-6 text-blue-500" />,
            title: "Transaction Management",
            description: "Blockchain Integration: Send, receive, activity logs, and last login history are stored on the blockchain for transparency and immutability",
            bgColor: "bg-purple-50/90",
        },
        {
            icon: <Globe2 className="w-6 h-6 text-pink-500" />,
            title: "Transaction and Card Security",
            description: "Three Attempt Lockout: After three incorrect pin attempts, the card will be temporarily blocked for 3 hours. Notifications of block status will be sent via SMS or email",
            bgColor: "bg-red-50/90",
        },
        {
            icon: <Send className="w-6 h-6 text-cyan-500" />,
            title: "Social and Referral Features",
            description: "Invite Options: Users can invite friends and family through SMS, WhatsApp, or other apps to expand the user base and drive organic growth.",
            bgColor: "bg-white/90",
        },
        {
            icon: <Shield className="w-6 h-6 text-violet-500" />,
            title: "Wallet Fund Management",
            description: "Virtual Balances with Admin Control: Similar to exchanges like Binance, user deposited funds will be directed to an admin wallet, while virtual balances are displayed for user convenience.",
            bgColor: "bg-purple-50/90",
        },
    ];

    return (
        <div>
            <div className="relative overflow-hidden bg-gradient-to-br from-[#fb6a2b] via-pink-500 to-[#e83f3b]">
                {/* Wave Pattern Overlay */}
                <div className="absolute inset-0 opacity-20">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-4 bg-white/20"
                            style={{
                                height: "200%",
                                left: `${i * 5}%`,
                                transform: "rotate(12deg)",
                                top: "-50%",
                            }}
                        />
                    ))}
                </div>

                <div className="relative max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
                        Effortless Onboarding,
                            <br />Flawless Transactions, and Instant Rewards
                        </h1>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {features.map((feature, index) => (
                            <div key={index} className={`rounded-2xl p-6 bg-opacity-5 border border-[#f7ddff] hover:scale-[1.3] transition-all ${feature.bgColor}`}>
                                <div className="mb-4">{feature.icon}</div>
                                <h3 className="text-[#6540b2] font-semibold text-lg mb-2">{feature.title}</h3>
                                <p className="text-slate-700 text-sm mb-4">{feature.description}</p>
                                {/* <Link to="/" className="text-[#fb6a2b] hover:text-[#fb432b] transition-all flex  text-sm font-medium items-center">
                                    Learn More <ChevronsRight className="w-4 h-4" />
                                </Link> */}
                            </div>
                        ))}
                    </div>
                </div>
                 
            </div>
        </div>
    );
};

export default SeamlessPayments;
